import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import {badgeConfig, linkSubscribe, AuthConfig, linkEarnPoints} from './../../../conf/config';

import * as authActions from './../../Auth/authActions';

import Aux from './../../../hoc/_Aux';

import Avatar from './../../../containers/UI/Avatar/Avatar';
import BadgeSummary from './../../UI/Common/BadgeSummary/BadgeSummary';
import Link from './../../../containers/UI/Link/Link';
import ClickableIcon from './../../../containers/UI/ClickableIcon/ClickableIcon';
import MessageModal from './../../../containers/UI/MessageModal/MessageModal';

import HistoryButton from './../../UI/Common/HistoryButton/HistoryButton';
import ShopButton from './../../UI/Common/ShopButton/ShopButton';

import Zigzag from './../../../containers/UI/Common/Shapes/Zigzag';

//test modal
import Modal from '../../UI/Modal/Modal';

//-- Utils
import { pushHeaderTitle } from '../../../utils/dom/helper';
import { pushPageView } from '../../../utils/tracking/customGtm';

//-- Assets 
import oopsSvg from './../../../assets/images/icons/oups.svg';

class Profile extends Component {
    
    // modal for badge description
    state = {
        showModal: false,
        modalBoutique: false,
        modalNotASubscriber: false
    }

    componentDidMount() {
        //-- Update title
        pushHeaderTitle('Mon super profil');

        //-- Push GTM page view
        pushPageView();
        
        this.setState({
            modalNotASubscriber: !this.props.isSubscriber && !this.props.subcriptionCheckInProgress
        })
    }
   
    mondalBetaBoutique = () => {
        const { dispatch } = this.props;
        dispatch(push('/store'));
    }

    modalCancelHandler = () => {
        this.setState({
            showModal: false, 
            modalBoutique: false,
            modalNotASubscriber: false
        });
    }

    modalDetailAbonnementLink = (event) => {
        event.preventDefault();
        window.open(linkSubscribe, '_blank');
    }

    modalAbonnementLink = (event) => {
        event.preventDefault();
        window.open(linkSubscribe, '_blank');
    }

    closeProfileHandler = () => {
        const { dispatch } = this.props;
        dispatch(push('/'));
    }

    goToContactPageHandler = () => {
        const { dispatch } = this.props;
        dispatch(push('/contact'));
    }

    logoutAction = (event) => {
        event.preventDefault();
        const { dispatch } = this.props;
        dispatch(authActions.logout());
    }

    editProfileHandler = () => {
        const { dispatch } = this.props;
        dispatch(push('/account/update'));
    }

    leadPageEarnPoint = (event) => {
        event.preventDefault();
        window.open(linkEarnPoints, '_blank');
    }

    getAge = () => {
        const { birthday } = this.props.user;
        let userAge = 0;
        if( birthday!=='' ){
            let DateBirthday = new Date( birthday );
            let ageDifMs = Date.now() - DateBirthday.getTime();
            let ageDate = new Date( ageDifMs );
            userAge = Math.abs( ageDate.getUTCFullYear() - 1970 );
        }
        
        return userAge;
    }

    getUserEarnedBagdes = () => {
        const { totalPoints } = this.props.points;
        var userBadgesStatus = [];

        for( var i=0; i<badgeConfig.length; i++ )
        {
            userBadgesStatus[i] = ( badgeConfig[i].pointsRequired <= totalPoints );
        }

        return userBadgesStatus; 
    }
    

    render(){
        const { user, points } = this.props;  

        let modalOutput = null;
        let modalClass = null;

        if (this.state.showModal && this.state.modalBoutique) {
            modalClass = 'trial-boutique';
            modalOutput = (
              <Aux>
                <div className="image"></div>
                <p className="big-text">Tu as vu un cadeau sympa?</p>
                <p className="small-text">Il faut être abonné pour commander dans la boutique</p>
              </Aux>
            );
        }

        let displayAge = [];
        const userAge = this.getAge();
        if ( userAge > 0 ) {
            displayAge.push(<span key="span-age-user-profile">{userAge > 1? `${userAge} ans`:`1 an`} </span>);
            
            if ( user.city !== '' ) {
                displayAge.push(<span key="span-age-user-profile-separator" className="separator">.</span>);

            }
        }

 
        return(
            <div className="profile-account-page">
                
                <Modal show={this.state.showModal} modalClosed={this.modalCancelHandler} class={modalClass}>
                    <div className="modal-container">
                        <div className="close-button" onClick={this.modalCancelHandler}></div>
                        {modalOutput}
                        {/* <button className="Success" onClick={this.modalContinueHandler}>CONTINUE</button> */}
                    </div>
                    <div className="blue-zigzag">  
                      <Zigzag color="#49d1e5"/>
                    </div>
                    <div className="yellow-zigzag">  
                      <Zigzag color="#ffde39"/>
                    </div>
                </Modal>

                <MessageModal 
                    show={this.state.modalNotASubscriber}
                    closeModalHandler={this.modalCancelHandler}
                    buttonHandler={this.modalDetailAbonnementLink}
                    image="error"
                    message="Aïe, tu es sûr que tes parents sont abonnés ?"
                    zigzagColor="#49d1e5"
                    zigzagClass="blue-shape"
                    buttonClass="small"
                />
                
                <div className="profile-container">
                    {this.props.isSubscriber?(<ClickableIcon name="close-profile" class="" action={this.closeProfileHandler} />):null}
                    
                    <Avatar avatarName={user.avatar} userName={user.username} isEditable="true" editableAction={this.editProfileHandler} />
                    <div className="user-info">
                        <h3>{user.username}</h3>
                        {displayAge}
                        <span>{user.city}</span>
                    </div>
                    
                    <BadgeSummary allBadges={badgeConfig} userBadges={this.getUserEarnedBagdes()} 
                                  currentPoints={points.currentPoints}
                    />
                
                    <div className="earnPointsLink" onClick={this.leadPageEarnPoint} >
                        Comment gagner des points ?
                    </div>

                    <Link key='profile-contact'
                        class='profile-contact'
                        clicked={ () =>this.goToContactPageHandler() }
                        target='#'>
                            contact
                    </Link>

                    <Link key=''
                        class='profile-logout'
                        clicked={ (event) =>this.logoutAction(event) }
                        target='#'>
                            Je me déconnecte
                    </Link> 
                </div>    
                <div className="profile-actions">
                  <HistoryButton className="history-btn"/>
                  <div className="profile-menu-middelbar" >
                    <Link key='profile-contact-footer'
                          class='profile-contact'
                          clicked={ () =>this.goToContactPageHandler() }
                          target='#'>
                              contact
                      </Link>
                  </div>
                  <ShopButton className="shop-btn" onClick={this.mondalBetaBoutique} />
                </div>    
            
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        uid: state.auth.uid,
        points: state.points,
        isSubscriber: state.auth.isSubscriber,
        subcriptionCheckInProgress: state.auth.subcriptionCheckInProgress
    }
};

export default connect( mapStateToProps )(Profile);


// WEBPACK FOOTER //
// ./src/components/Account/Profile/Profile.js